<template>
  <div class="anthemBG">
    <div class="panel" ref="panel" style="transform:scale(1)">
      <div class="panelTop">
        <div class="title">Leaderboard: top 10</div>
        <div class="subTitle" >Making top 10 or not, you’re amazing for playing our game.</div>
        <div v-if="pageWidth>=900">
          <div class="searchRow">
            <div> Difficulty
              <div class="diffRow" >
                <Selector @selected="doSelect" ref="selectorX"></Selector>
              </div>
            </div>
            <div>FIND YOUR SCORE
              <SearchBox class="searchBox" @showScore="showScore" @results="showResults" :placeHolder="'Your Name'"  :items="names"  :validation="['inList']" />
            </div>
          </div>
      </div>
      <div v-else>
         <div style="  z-index: 1;position: relative;">FIND YOUR SCORE 
            <SearchBox  class="searchBox" @showScore="showScore" @results="showResults" :placeHolder="'Your Name'"  :items="names"  :validation="['inList']" />
          </div>
          <div> Difficulty 
              <div class="diffRow" >
                <SelectorDD @selected="doSelect" ref="selectorX"></SelectorDD>
              </div>
            </div>
      </div>
    </div> 
    <div :class="difficulty">
    <TopTen  v-show="difficulty=='Advanced'" :scores="scoreType('Advanced')" :heading="'Advanced'"  :highlight="selectedName" />
    <TopTen v-show="difficulty=='Intermediate'" :scores="scoreType('Intermediate')" :heading="'Intermediate'"  :highlight="selectedName"/>
    <TopTen v-show="difficulty=='Beginner'" :scores="scoreType('Beginner')" :heading="'Beginner'"  :highlight="selectedName"/>
    <TopTen v-show="difficulty=='Novice'" :scores="scoreType('Novice')" :heading="'Novice'"  :highlight="selectedName"/>
    <TopTen v-show="difficulty=='Relaxed'" :scores="scoreType('Relaxed')" :heading="'Relaxed'"  :highlight="selectedName"/>
 </div>
 <div class="panelBase">
  <router-link to="/global" tag="button" class="pillBtn">See Full Leaderboard</router-link> 
 </div>
  </div>
  <div class="anthemIcon" style="transform:scale(1.5);top:10px;"></div>
  </div>
</template>

<script>
// @ is an alias to /src
import TopTen from '@/components/TopTen.vue'
import SearchBox from '@/components/SearchBoxM.vue'
import Selector from '@/components/Selector.vue'
import SelectorDD from '@/components/SelectorDD.vue'

export default {
  name: 'Home',
  components: {
    TopTen,SearchBox,Selector,SelectorDD
  },
  data() {
      return {
        selectedName:null,
        difficulty:"Advanced",
        difficulties:[{name:"Advanced",color:"#FF8226"},
              {name:"Intermediate",color:"#FF9D00"},
               {name:"Beginner",color:"#FF9D00"},
               {name:"Novice",color:"#F9EC6B"},
               {name:"Relaxed",color:"#81D499"}],
        results:"",
        pageWidth:600
      }
  },
  mounted(){
   this.setPageWidth()
   window.onresize=this.setPageWidth
  },
  computed:{
    scores(){
      let scores=this.$store.getters.getScores
      if (scores){
        return scores.sort( highScore )
      }
      return []
    },
     names(){
      return this.$store.getters.getNames || ["xxx"] 
    },
  },
  methods:{
    setPageWidth(){
      this.pageWidth=this.$refs.panel.offsetWidth
      //this.pageWidth=this.$refs.selectorX.offsetWidth
    },
    showResults(val){
      this.results=val
    },
    doSelect(val){
      console.log("SELECTED",val)
      this.difficulty=val
    },
    showScore(val){
      this.selectedName=val
      console.log("ShowScore",val)
      let maxDiff=null
      for (var d in this.difficulties){
        console.log("CHECK",this.difficulties[d].name)
        if(!maxDiff && this.containsPlayer(this.scoreType(this.difficulties[d].name),val)){
          maxDiff=this.difficulties[d].name
        }
      }
      if(maxDiff){
        //this.difficulty=maxDiff
        this.$refs.selectorX.setValue(maxDiff)
      }
      
      console.log("MAX DIFF",maxDiff)
    },
    scoreType(sType){
      let scores=[]
      for(var s in this.scores){
        if(this.scores[s].Difficulty==sType){
          scores.push(this.scores[s])
        }
      }
      return scores.sort( highScore );
    },
    containsPlayer(scores,name){
    let found = false
    console.log("check",scores,name)
    for(var s=0;s<scores.length && !found; s++){
      if(scores[s].Name==name){
        found=true
      }
    }
    return found
  }
  }
  
}

function highScore( a, b ) {
  if ( a.score < b.score ){
    return 1;
  }
  if ( a.score> b.score ){
    return -1;
  }
  return 0;
}
</script>
<style lang="scss" >
@import "@/css/colors.scss";
 
  .home{
    width:100%;
  }
  .anthemBG{
    padding:7em 2em;
  }
  
  .PanelBG{
    transition: background-color 0.15s ease-in;
  }
  .Advanced{
    background-color: $advanced-color;
    color:#000;
    
     transition: background-color 0.15s ease-in;
  }
  .Intermediate{
    background-color: $intermediate-color;
    color:#000;
  
     transition: background-color 0.15s ease-in;
  }
   .Beginner{
   background-color:$beginner-color;
  }
 .Novice{
   background-color:$novice-color;
 }
 .Relaxed{
   background-color:$relaxed-color;
 }

 :root {
	--primary-color: #185ee0;
	--secondary-color: #e6eef9;
}

*,
*:after,
*:before {
	box-sizing: border-box;
}
.rowSelected{
    background-color:#eef7ee;
     border-top:solid 5px $row-highlight-border!important;
     margin-top:0px!important;
    
    
  }
  @media only screen and (max-width: 620px) {
    .panel{
      font-size:15px;
      border-radius:0em;
    }
    .panelTop{
      padding:2.5em 2em;
    }
    .anthemBG{
      padding:7em 0em;
    }
    .title{
      font-size:2.1em;
    }
  }
  @media only screen and (max-width: 520px) {
  .panel{
      font-size:14px;
    }
    .title{
      font-size:2.31em;
    }
  }

</style>
